import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["server_code", "كود السيرفر (cfx.re/join/...)", "ltr"],
  ["discord_invite", "رابط دعوة الديسكورد", "ltr"],
  ["webhook_url", "Webhook للتنبيه بالتقديمات الجديدة", "ltr"],
  ["open_at", "موعد افتتاح المدينة (عد تنازلي)", "datetime"],
  ["youtube_url", "رابط اليوتيوب", "ltr"],
  ["tiktok_url", "رابط التيك توك", "ltr"],
  ["success_message", "رسالة بعد إرسال التقديم", "area"],
  ["admin_ids", "Discord ID للإدارة (كل سطر واحد)", "ids"],
];

const toLocal = (iso) => (iso ? new Date(new Date(iso).getTime() - new Date().getTimezoneOffset() * 6e4).toISOString().slice(0, 16) : "");

export default function AdminSettings() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["admin-settings"], queryFn: () => api.get("/admin/settings").then((r) => r.data) });
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) setS(data); }, [data]);
  if (!s) return <div className="h-64 animate-pulse rounded-2xl bg-slate-900/60" />;
  const set = (k, v) => setS({ ...s, [k]: v });
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put("/admin/settings", s);
      setS(r.data); qc.invalidateQueries({ queryKey: ["settings"] }); qc.invalidateQueries({ queryKey: ["status"] });
      toast.success("انحفظت الإعدادات");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="glass max-w-3xl space-y-5 rounded-3xl p-7" data-testid="admin-settings">
      <label className="flex items-center justify-between rounded-xl border border-sky-400/15 bg-black/30 p-4">
        <span><b>التقديم على المدينة</b><span className="block text-xs text-slate-500">فتح وقفل فورم التقديم على المدينة. الأقسام تفتحها وتقفلها من محتوى الموقع، ثم الأقسام.</span></span>
        <input type="checkbox" checked={!!s.city_apply_open} onChange={(e) => set("city_apply_open", e.target.checked)} className="h-5 w-5 accent-sky-400" data-testid="settings-city-open" />
      </label>
      {FIELDS.map(([k, label, kind]) => (
        <label key={k} className="block">
          <span className="mb-1.5 block text-xs text-slate-400">{label}</span>
          {kind === "area" ? <textarea rows={8} className="field" value={s[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`settings-${k}`} />
            : kind === "ids" ? <textarea rows={3} dir="ltr" className="field font-mono2" value={(s[k] || []).join("\n")} onChange={(e) => set(k, e.target.value.split("\n"))} data-testid={`settings-${k}`} />
            : kind === "datetime" ? <div className="flex gap-2"><input type="datetime-local" className="field" value={toLocal(s[k])} onChange={(e) => set(k, e.target.value ? new Date(e.target.value).toISOString() : "")} data-testid={`settings-${k}`} /><button type="button" onClick={() => set(k, "")} className="btn-ghost shrink-0 !py-2" data-testid="settings-open-now">مفتوحة الحين</button></div>
            : <input dir="ltr" className="field" value={s[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`settings-${k}`} />}
        </label>
      ))}
      <button onClick={save} disabled={busy} className="btn-ice" data-testid="settings-save-btn"><Save size={16} />{busy ? "يحفظ..." : "حفظ الإعدادات"}</button>
    </div>
  );
}
